import { Observable } from "rxjs";

export abstract class IVATService {
  abstract getVatByNumber(number: String): Observable<any>;
  abstract saveVat(vat: any): Observable<any>;
}
